<template>
  <div>
    <Topo />
    <div class="container-fluid mt-3">
      <div class="container pt-4">
        <h3><i class="fa fa-lock mr-2"></i>Redefinição de Senha</h3>
      </div>
    </div>
    <div class="container mt-content mb-5">
      <b-card header-tag="header">
        <b slot="header" class="mb-0">Preencha os campos abaixo para redefinir a sua senha</b>
        <b-card-text>
          <div v-if="redefinida" class="text-center">
            <b-alert variant="success" show class="text-center pt-4 pb-4">
              <i class="fa fa-check-circle-o text-success mr-2" style="font-size: 2rem;" aria-hidden="true"></i>
              <b style="font-size: 1.5rem;">Senha redefinida com sucesso!</b>
            </b-alert>
            <router-link class="btn btn-primary mt-3 mb-2" to="/">Acessar área do congressista</router-link>
          </div>
          <b-form v-else @submit="onSubmit">
            <div class="row mb-3">
              <div class="col-md-3">
                <b-form-group label="Senha" label-for="senha">
                  <b-form-input id="senha" size="sm" type="password" maxlength="20"
                    placeholder="mínimo de 6 caracteres"
                    v-model.trim="$v.form.senha.$model"
                    :state="$v.form.senha.$dirty ? !$v.form.senha.$error : null"
                    aria-describedby="input-1-live-feedback">
                  </b-form-input>
                  <b-form-invalid-feedback id="input-1-live-feedback">
                    <div v-if="!$v.form.senha.required">Campo obrigatório</div>
                    <div v-if="!$v.form.senha.minLength">Mínimo de 6 caracteres</div>
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Redigite" label-for="redigite">
                  <b-form-input id="redigite" size="sm" type="password" maxlength="20"
                    v-model.trim="$v.form.redigite.$model"
                    :state="$v.form.redigite.$dirty ? !$v.form.redigite.$error : null"
                    aria-describedby="input-1-live-feedback">
                  </b-form-input>
                  <b-form-invalid-feedback id="input-1-live-feedback">
                    <div v-if="!$v.form.redigite.required">Campo obrigatório</div>
                    <div v-if="!$v.form.redigite.sameAsPassword">Redigitação da senha não confere!</div>
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Lembrete da Senha" label-for="lembrete">
                  <b-form-input id="lembrete" size="sm" maxlength="50"
                    v-model.trim="$v.form.lembrete.$model"
                    :state="$v.form.lembrete.$dirty ? !$v.form.lembrete.$error : null"
                    aria-describedby="input-1-live-feedback">
                  </b-form-input>
                  <b-form-invalid-feedback id="input-1-live-feedback">Campo obrigatório</b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-center">
                <b-button v-if="!trabalhando" type="submit" variant="primary">Alterar senha</b-button>
                <b-button v-else variant="primary" disabled>
                  <b-spinner small class="mr-2"></b-spinner>Trabalhando...
                </b-button>
              </div>
            </div>
          </b-form>
        </b-card-text>
      </b-card>
    </div>
  </div>
</template>

<script>

import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import Topo from '@/components/Topo.vue'

export default {
  name: 'RedefinirSenha',
  components: { Topo },
  data: function () {
    return {
      form: {
        senha: '',
        redigite: '',
        lembrete: '',
        troca_senha: 0
      },
      trabalhando: false,
      redefinida: false
    }
  },
  validations () {
    return {
      form: {
        senha: {
          required,
          minLength: minLength(6)
        },
        redigite: { required, sameAsPassword: sameAs('senha') },
        lembrete: { required }
      }
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$toasted.global.defaultError({ msg: 'Por favor, verifique os erros no formulário' })
      } else {
        this.trabalhando = true
        axios.put(`${baseApiUrl}/redefine_senha/${this.$route.params.id_crip}`, this.form)
          .then(() => {
            this.redefinida = true
            // this.$toasted.global.defaultSuccess('Senha redefinida com sucesso!')
            this.trabalhando = false
          })
          .catch(err => {
            showError(err)
            this.trabalhando = false
          })
      }
    },
    VerificaseTrocaSenha () {
      axios.get(`${baseApiUrl}/verifica_se_troca_senha/${this.$route.params.id_crip}`)
        .then(res => {
          if (res.data.qt === 0) {
            this.$router.push({ path: '/' })
          }
        })
        .catch(err => {
          showError(err)
        })
    }
  },
  mounted () {
    if (!this.$route.params.id_crip) {
      this.$router.push({ path: '/' })
    } else {
      this.VerificaseTrocaSenha()
    }
  }
}
</script>
